import React from 'react';
import { HStack, Icon, Pressable, Text } from '@gluestack-ui/themed';
import * as Clipboard from 'expo-clipboard';
import { Copy, Check } from 'lucide-react-native';
import { useFormContext } from 'react-hook-form';
import log from '@/common/utils/logger';

const ObjectIdField = ({ propertyName = 'id' }) => {
  const { watch } = useFormContext();
  const [copied, setCopied] = React.useState(false);
  const value = watch(propertyName);

  const handleCopy = async () => {
    if (!value) return;
    try {
      await Clipboard.setStringAsync(String(value));
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (e) {
      log.error('Failed to copy ID:', e);
    }
  };

  return (
    <HStack alignItems="center" space="xs">
      <Text size="xs" color="$textLight500">
        ID: {value}
      </Text>
      {!!value && (
        <Pressable onPress={handleCopy} hitSlop={8} ml="$1" accessibilityLabel="Copy ID">
          <Icon as={copied ? Check : Copy} size="2xs" color="$textLight400" />
        </Pressable>
      )}
    </HStack>
  );
};

export default ObjectIdField;
